"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setVerificationStateEndpoint = void 0;
const endpointIds_1 = require("root/src/shared/descriptions/endpoints/endpointIds");
const auth_1 = require("root/src/shared/constants/auth");
const lenses_1 = require("root/src/shared/descriptions/endpoints/lenses");
const setVerificationStatePayloadSchema_1 = require("root/src/shared/descriptions/endpoints/schemas/requestSchemas/setVerificationStatePayloadSchema");
const payloadSchema = setVerificationStatePayloadSchema_1.setVerificationStatePayloadSchema;
exports.setVerificationStateEndpoint = {
    [endpointIds_1.SET_VERIFICATION_STATE]: {
        authentication: auth_1.authenticationTypes.authenticated,
        authenticationRole: auth_1.userGroups.admin,
        endpointType: lenses_1.otherEndpointType,
        payloadSchema,
    },
};
